import React, { useLayoutEffect, useRef, useState } from 'react';

export default function ProductThumbnailStrip({ children }) {
  const stripRef = useRef(null);
  const [edges, setEdges] = useState({ left: false, right: false });

  useLayoutEffect(() => {
    const strip = stripRef.current;
    const updateEdges = () => {
      const left = strip.scrollLeft > 1;
      const right = strip.scrollWidth - strip.clientWidth - strip.scrollLeft > 1;
      setEdges(previous => previous.left === left && previous.right === right ? previous : { left, right });
    };
    updateEdges();
    const observer = new ResizeObserver(updateEdges);
    observer.observe(strip);
    strip.addEventListener('scroll', updateEdges, { passive: true });
    return () => {
      observer.disconnect();
      strip.removeEventListener('scroll', updateEdges);
    };
  }, [children]);

  return (
    <div className="relative min-w-0">
      <div
        ref={stripRef}
        role="region"
        aria-label="Product gallery thumbnails"
        tabIndex={0}
        className="grid grid-flow-col auto-cols-[calc((100%-36px)/4)] lg:auto-cols-[calc((100%-60px)/6)] gap-3 overflow-x-auto overscroll-x-contain snap-x snap-proximity pb-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)]"
      >
        {children}
      </div>
      {edges.left && <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-white/95 to-transparent" />}
      {edges.right && <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-white/95 to-transparent" />}
    </div>
  );
}
